exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{width:100%;position:relative}.fixed-header+.app-main[data-v-078753dd]{padding-top:60px}.hasTagsView .app-main[data-v-078753dd]{min-height:calc(100vh - 84px)}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:84px}\n", ""]);

// exports
